module.exports = __webpack_public_path__ + "62d6ed06ecd0d452e1a41663ee527f34.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/_iview@3.5.4@iview/dist/styles/fonts/ionicons.ttf?v=3.0.0
// module id = 815
// module chunks = 9